import React from "react";

const Book = () => {
  return (
    <div className="textAlign">
      Currently no books are available.
      {/* *****Uncomment this for adding content in Books***** */}
      {/* <b>
        Singh JK and Verma N,
        <font color="118D76">
          "Aqueous Phase Adsorption: Theory, Simulations and Experiments".
        </font>
        <font color="E8350F">CRC Press, ISBN 978-1138575219 (2019)</font>
      </b>
  <br /> */}
    </div>
  );
};

export default Book;
